import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { ScrollToTop } from './components/ScrollToTop';
import { BrandPortalPage } from './pages/BrandPortalPage';
import { HomePage } from './pages/HomePage';
import { InvestorPage } from './pages/InvestorPage';
import { PlatformPage } from './pages/PlatformPage';
import { ProductPage } from './pages/ProductPage';
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="2rlyr0hc56qkk">
      <ScrollToTop data-id="element-1" data-mp="2rlf74v2xls3w" />
      <Routes data-id="element-2" data-mp="2rit2p4bc7spw">
        <Route path="/" element={<HomePage data-id="element-4" data-mp="2mmcc83go129n" />} data-id="element-3" data-mp="2mlu9qp3etrta" />
        <Route path="/products/:slug" element={<ProductPage data-id="element-6" data-mp="2mjzm330r7lli" />} data-id="element-5" data-mp="2mn5bkjdaophr" />
        <Route path="/platform" element={<PlatformPage data-id="element-8" data-mp="31bibtsjf0ui2" />} data-id="element-7" data-mp="31agq8u4rwpm3" />
        <Route path="/brand" element={<BrandPortalPage data-id="element-10" data-mp="2wka0us2ft12s" />} data-id="element-9" data-mp="31cte1nx7pu72" />
        <Route path="/investor" element={<InvestorPage data-id="element-12" data-mp="2wip734ny5m5z" />} data-id="element-11" data-mp="2wiyxgtcwlvc7" />
      </Routes>
    </BrowserRouter>;
}